import React, { CSSProperties, FC, ReactNode } from "react";

type Props = {
  children: ReactNode;
  className?: string;
  cols?: number;
};

export const GridContainer: FC<Props> = ({
  children,
  className = "",
  cols,
}) => {
  const gridStyle: CSSProperties = cols
    ? {
        display: "grid",
        gridTemplateColumns: `repeat(${cols}, 1fr)`,
      }
    : {};

  return (
    <div
      className={`bg-white rounded-lg shadow-sm border border-secondary-200 overflow-hidden ${className}`}
      style={gridStyle}
    >
      {children}
    </div>
  );
};
